import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "py-4" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_4 = { style: {"font-size":"18px","font-weight":"bold"} }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"#e6a23c"} }, "⚠️", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 充值确认 — ")
const _hoisted_7 = { style: {"color":"#409EFF","font-weight":"bold"} }
const _hoisted_8 = { style: {"color":"#F56C6C","font-size":"18px","font-weight":"bold"} }
const _hoisted_9 = { style: {"color":"#F56C6C","font-size":"20px","font-weight":"bold"} }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 确认充值 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      ref: "formRef",
      rules: _ctx.rules,
      model: _ctx.add_balance_record,
      "label-width": "120px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "用户手机号码",
          prop: "mobile"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.add_balance_record.mobile,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.add_balance_record.mobile) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: _ctx.balanceLabel,
          prop: "balance"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.add_balance_record.balance,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.add_balance_record.balance) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: "备注",
          prop: "note"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.add_balance_record.note,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.add_balance_record.note) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onSubmit(_ctx.formRef))),
              loading: _ctx.lookupLoading
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }, 8, ["loading"]),
            _createVNode(_component_el_button, { onClick: _ctx.onCancel }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["rules", "model"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.confirmDialogVisible,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.confirmDialogVisible) = $event)),
      width: "500px",
      "close-on-click-modal": false
    }, {
      header: _withCtx(() => [
        _createElementVNode("span", _hoisted_4, [
          _hoisted_5,
          _hoisted_6,
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.balanceLabel) + "充值", 1)
        ])
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.confirmDialogVisible = false))
        }, {
          default: _withCtx(() => [
            _hoisted_10
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.doCreate,
          loading: _ctx.isSubmit
        }, {
          default: _withCtx(() => [
            _hoisted_11
          ]),
          _: 1
        }, 8, ["onClick", "loading"])
      ]),
      default: _withCtx(() => [
        (Number(_ctx.add_balance_record.balance) >= 50000)
          ? (_openBlock(), _createBlock(_component_el_alert, {
              key: 0,
              title: "⚠️ 大额充值，请仔细核对",
              type: "warning",
              closable: false,
              "show-icon": "",
              style: {"margin-bottom":"16px"}
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_descriptions, {
          column: 1,
          border: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_descriptions_item, { label: "用户昵称" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.lookupUser.nickname), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "用户 ID" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.lookupUser.id), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "手机号" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.lookupUser.mobile), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "当前余额" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.lookupUser.balance), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "充值金额" }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.add_balance_record.balance), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "充值后余额" }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.projectedBalance), 1)
              ]),
              _: 1
            }),
            (_ctx.add_balance_record.note)
              ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
                  key: 0,
                  label: "备注"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.add_balance_record.note), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}